import { MerchantCenterSmallSvgIcon } from '@commercetools-docs/ui-kit';

export default MerchantCenterSmallSvgIcon;
